import { gql } from '@apollo/client'

export const BULK_DELETE_AUDIT_QUESTIONS = gql`
  mutation BulkDeleteAuditQuestions($input: BulkDeleteInput!) {
    bulkDeleteAuditQuestions(input: $input) {
      deleted
    }
  }
`
